/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  Deletable,
  DeletableOptional,
  DeletableMetaI,
  DeletableTrackedI,
} from "./deletable";
import { DeletableTracked, DeletableMeta } from "./deletable";
// May contain unused imports in some cases
// @ts-ignore
import type {
  DonationBase,
  DonationBaseOptional,
  DonationBaseMetaI,
  DonationBaseTrackedI,
} from "./donation-base";
import { DonationBaseTracked, DonationBaseMeta } from "./donation-base";
// May contain unused imports in some cases
// @ts-ignore
import type {
  DonationFundRef,
  DonationFundRefOptional,
  DonationFundRefMetaI,
  DonationFundRefTrackedI,
} from "./donation-fund-ref";
import {
  DonationFundRefTracked,
  DonationFundRefMeta,
} from "./donation-fund-ref";
// May contain unused imports in some cases
// @ts-ignore
import type {
  DonationInitiativeRef,
  DonationInitiativeRefOptional,
  DonationInitiativeRefMetaI,
  DonationInitiativeRefTrackedI,
} from "./donation-initiative-ref";
import {
  DonationInitiativeRefTracked,
  DonationInitiativeRefMeta,
} from "./donation-initiative-ref";
// May contain unused imports in some cases
// @ts-ignore
import type {
  DonationRef,
  DonationRefOptional,
  DonationRefMetaI,
  DonationRefTrackedI,
} from "./donation-ref";
import { DonationRefTracked, DonationRefMeta } from "./donation-ref";
// May contain unused imports in some cases
// @ts-ignore
import type {
  PersonRef,
  PersonRefOptional,
  PersonRefMetaI,
  PersonRefTrackedI,
} from "./person-ref";
import { PersonRefTracked, PersonRefMeta } from "./person-ref";
// May contain unused imports in some cases
// @ts-ignore
import type {
  PurchasableState,
  PurchasableStateOptional,
  PurchasableStateMetaI,
  PurchasableStateTrackedI,
} from "./purchasable-state";
import {
  PurchasableStateTracked,
  PurchasableStateMeta,
} from "./purchasable-state";
// May contain unused imports in some cases
// @ts-ignore
import type {
  WithOptionalPersonRef,
  WithOptionalPersonRefOptional,
  WithOptionalPersonRefMetaI,
  WithOptionalPersonRefTrackedI,
} from "./with-optional-person-ref";
import {
  WithOptionalPersonRefTracked,
  WithOptionalPersonRefMeta,
} from "./with-optional-person-ref";

/**
 *
 * @export
 * @interface DonationFull
 */
export interface DonationFullOptional extends DeletableOptional {
  /**
   *
   * @type {boolean}
   * @memberof DonationFull
   */
  isDeleted?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof DonationFull
   */
  isNew?: boolean;
  /**
   *
   * @type {number}
   * @memberof DonationFull
   */
  donationId?: number;
  /**
   *
   * @type {number}
   * @memberof DonationFull
   */
  price?: number;
  /**
   *
   * @type {PurchasableState}
   * @memberof DonationFull
   */
  purchasableState?: PurchasableState;
  /**
   *
   * @type {string}
   * @memberof DonationFull
   */
  purchaseDate?: Date;
  /**
   *
   * @type {number}
   * @memberof DonationFull
   */
  voidCloseId?: number;
  /**
   *
   * @type {DonationFundRef}
   * @memberof DonationFull
   */
  fundId?: DonationFundRefOptional;
  /**
   *
   * @type {string}
   * @memberof DonationFull
   */
  donationDate?: Date;
  /**
   *
   * @type {string}
   * @memberof DonationFull
   */
  description?: string;
  /**
   *
   * @type {string}
   * @memberof DonationFull
   */
  restriction?: string;
  /**
   *
   * @type {DonationInitiativeRef}
   * @memberof DonationFull
   */
  initiativeId?: DonationInitiativeRefOptional;
  /**
   *
   * @type {string}
   * @memberof DonationFull
   */
  inMemoryOf?: string;
  /**
   *
   * @type {boolean}
   * @memberof DonationFull
   */
  isMatch?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof DonationFull
   */
  inKind?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof DonationFull
   */
  skipAck?: boolean;
  /**
   *
   * @type {PersonRef}
   * @memberof DonationFull
   */
  personId?: PersonRefOptional;
}

export interface DonationFull
  extends
    DonationFullOptional,
    Deletable,
    DonationBase,
    DonationRef,
    WithOptionalPersonRef {
  /**
   *
   * @type {boolean}
   * @memberof DonationFull
   */
  isDeleted?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof DonationFull
   */
  isNew?: boolean;
  /**
   *
   * @type {number}
   * @memberof DonationFull
   */
  donationId: number;
  /**
   *
   * @type {number}
   * @memberof DonationFull
   */
  price?: number;
  /**
   *
   * @type {PurchasableState}
   * @memberof DonationFull
   */
  purchasableState?: PurchasableState;
  /**
   *
   * @type {string}
   * @memberof DonationFull
   */
  purchaseDate?: Date;
  /**
   *
   * @type {number}
   * @memberof DonationFull
   */
  voidCloseId?: number;
  /**
   *
   * @type {DonationFundRef}
   * @memberof DonationFull
   */
  fundId: DonationFundRef;
  /**
   *
   * @type {string}
   * @memberof DonationFull
   */
  donationDate?: Date;
  /**
   *
   * @type {string}
   * @memberof DonationFull
   */
  description?: string;
  /**
   *
   * @type {string}
   * @memberof DonationFull
   */
  restriction?: string;
  /**
   *
   * @type {DonationInitiativeRef}
   * @memberof DonationFull
   */
  initiativeId: DonationInitiativeRef;
  /**
   *
   * @type {string}
   * @memberof DonationFull
   */
  inMemoryOf?: string;
  /**
   *
   * @type {boolean}
   * @memberof DonationFull
   */
  isMatch?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof DonationFull
   */
  inKind?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof DonationFull
   */
  skipAck?: boolean;
  /**
   *
   * @type {PersonRef}
   * @memberof DonationFull
   */
  personId?: PersonRef;
}

export interface DonationFullTrackedI extends DeletableOptional {
  /**
   *
   * @type {boolean}
   * @memberof DonationFull
   */
  isDeleted?: boolean;
  isDeletedIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof DonationFull
   */
  isNew?: boolean;
  isNewIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof DonationFull
   */
  donationId?: number;
  donationIdIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof DonationFull
   */
  price?: number;
  priceIsSet: boolean;
  /**
   *
   * @type {PurchasableState}
   * @memberof DonationFull
   */
  purchasableState?: PurchasableState;
  purchasableStateIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof DonationFull
   */
  purchaseDate?: Date;
  purchaseDateIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof DonationFull
   */
  voidCloseId?: number;
  voidCloseIdIsSet: boolean;
  /**
   *
   * @type {DonationFundRef}
   * @memberof DonationFull
   */
  fundId?: DonationFundRefTrackedI;
  fundIdIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof DonationFull
   */
  donationDate?: Date;
  donationDateIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof DonationFull
   */
  description?: string;
  descriptionIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof DonationFull
   */
  restriction?: string;
  restrictionIsSet: boolean;
  /**
   *
   * @type {DonationInitiativeRef}
   * @memberof DonationFull
   */
  initiativeId?: DonationInitiativeRefTrackedI;
  initiativeIdIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof DonationFull
   */
  inMemoryOf?: string;
  inMemoryOfIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof DonationFull
   */
  isMatch?: boolean;
  isMatchIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof DonationFull
   */
  inKind?: boolean;
  inKindIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof DonationFull
   */
  skipAck?: boolean;
  skipAckIsSet: boolean;
  /**
   *
   * @type {PersonRef}
   * @memberof DonationFull
   */
  personId?: PersonRefTrackedI;
  personIdIsSet: boolean;
}

transformDatesMap.set("DonationFull", function (model: DonationFull) {
  if (typeof model.purchaseDate == "string")
    model.purchaseDate = new Date(model.purchaseDate);
  const transformDatesfundId = transformDatesMap.get("DonationFundRef");
  if (transformDatesfundId && model.fundId) {
    transformDatesfundId(model.fundId);
  }
  if (typeof model.donationDate == "string")
    model.donationDate = new Date(model.donationDate);
  const transformDatesinitiativeId = transformDatesMap.get(
    "DonationInitiativeRef",
  );
  if (transformDatesinitiativeId && model.initiativeId) {
    transformDatesinitiativeId(model.initiativeId);
  }
  const transformDatespersonId = transformDatesMap.get("PersonRef");
  if (transformDatespersonId && model.personId) {
    transformDatespersonId(model.personId);
  }
});

export type DonationFullMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  isDeleted: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  isNew: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  donationId: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  price: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  purchasableState: PropertyMeta<PurchasableStateMetaI>;
  //isDate: false
  //isDatetime: true
  purchaseDate: PropertyMeta<MetaTypeBase<Date>>;
  //isDate: false
  //isDatetime: false
  voidCloseId: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  fundId: PropertyMeta<DonationFundRefMetaI>;
  //isDate: false
  //isDatetime: true
  donationDate: PropertyMeta<MetaTypeBase<Date>>;
  //isDate: false
  //isDatetime: false
  description: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  restriction: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  initiativeId: PropertyMeta<DonationInitiativeRefMetaI>;
  //isDate: false
  //isDatetime: false
  inMemoryOf: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  isMatch: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  inKind: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  skipAck: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  personId: PropertyMeta<PersonRefMetaI>;
}>;

export var DonationFullMeta: DonationFullMetaI = {} as DonationFullMetaI;
DonationFullMeta = typeMeta("DonationFull", {
  isDeleted: propertyMeta(
    "isDeleted",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
  isNew: propertyMeta("isNew", false, false, false, MetaTypesBase.boolean),
  donationId: propertyMeta(
    "donationId",
    false,
    true,
    true,
    MetaTypesBase.number,
  ),
  price: propertyMeta("price", false, false, false, MetaTypesBase.number),
  purchasableState: propertyMeta(
    "purchasableState",
    false,
    false,
    false,
    PurchasableStateMeta,
  ),
  purchaseDate: propertyMeta(
    "purchaseDate",
    false,
    false,
    false,
    MetaTypesBase.Date,
  ),
  voidCloseId: propertyMeta(
    "voidCloseId",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  fundId: propertyMeta("fundId", false, true, false, DonationFundRefMeta),
  donationDate: propertyMeta(
    "donationDate",
    false,
    false,
    false,
    MetaTypesBase.Date,
  ),
  description: propertyMeta(
    "description",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  restriction: propertyMeta(
    "restriction",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  initiativeId: propertyMeta(
    "initiativeId",
    false,
    true,
    false,
    DonationInitiativeRefMeta,
  ),
  inMemoryOf: propertyMeta(
    "inMemoryOf",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  isMatch: propertyMeta("isMatch", false, false, false, MetaTypesBase.boolean),
  inKind: propertyMeta("inKind", false, false, false, MetaTypesBase.boolean),
  skipAck: propertyMeta("skipAck", false, false, false, MetaTypesBase.boolean),
  personId: propertyMeta("personId", false, false, false, PersonRefMeta),
});

const metaI = DonationFullMeta;

registerMeta(() => {
  metaI.interfaces = metaI.interfaces.concat([DeletableMeta]);
  metaI.isDeleted.inheritedFrom = DeletableMeta.isDeleted;
  metaI.isNew.inheritedFrom = DeletableMeta.isNew;
  metaI.interfaces = metaI.interfaces.concat([DonationRefMeta]);
  metaI.donationId.inheritedFrom = DonationRefMeta.donationId;
  metaI.interfaces = metaI.interfaces.concat([DonationBaseMeta]);
  metaI.price.inheritedFrom = DonationBaseMeta.price;
  metaI.purchasableState.inheritedFrom = DonationBaseMeta.purchasableState;
  metaI.purchaseDate.inheritedFrom = DonationBaseMeta.purchaseDate;
  metaI.voidCloseId.inheritedFrom = DonationBaseMeta.voidCloseId;
  metaI.fundId.inheritedFrom = DonationBaseMeta.fundId;
  metaI.donationDate.inheritedFrom = DonationBaseMeta.donationDate;
  metaI.description.inheritedFrom = DonationBaseMeta.description;
  metaI.restriction.inheritedFrom = DonationBaseMeta.restriction;
  metaI.initiativeId.inheritedFrom = DonationBaseMeta.initiativeId;
  metaI.inMemoryOf.inheritedFrom = DonationBaseMeta.inMemoryOf;
  metaI.isMatch.inheritedFrom = DonationBaseMeta.isMatch;
  metaI.inKind.inheritedFrom = DonationBaseMeta.inKind;
  metaI.skipAck.inheritedFrom = DonationBaseMeta.skipAck;
  metaI.interfaces = metaI.interfaces.concat([WithOptionalPersonRefMeta]);
  metaI.personId.inheritedFrom = WithOptionalPersonRefMeta.personId;
});

export class DonationFullTracked
  extends DeletableTracked
  implements DonationFullTrackedI
{
  changeTracker: boolean = false;
  //isNew: boolean = false
  isDeleted__I?: boolean = undefined;
  isDeletedIsSet: boolean = false;
  set isDeleted(v: undefined | boolean) {
    if (v !== undefined) {
      this.isDeleted__I = v;
      this.isDeletedIsSet = true;
    } else {
      this.isDeleted__I = v || undefined;
      this.isDeletedIsSet = false;
    }
    this.changeTracker = true;
  }
  get isDeleted() {
    return this.isDeleted__I;
  }
  isNew__I?: boolean = undefined;
  isNewIsSet: boolean = false;
  set isNew(v: undefined | boolean) {
    if (v !== undefined) {
      this.isNew__I = v;
      this.isNewIsSet = true;
    } else {
      this.isNew__I = v || undefined;
      this.isNewIsSet = false;
    }
    this.changeTracker = true;
  }
  get isNew() {
    return this.isNew__I;
  }
  donationId__I?: number = undefined;

  get donationIdIsSet() {
    return this.donationId !== undefined;
  }
  set donationIdIsSet(v: boolean) {}
  set donationId(v: undefined | number) {
    if (v !== undefined) {
      this.donationId__I = v;
      this.donationIdIsSet = true;
    } else {
      this.donationId__I = v || undefined;
      this.donationIdIsSet = true;
    }
    this.changeTracker = true;
  }
  get donationId() {
    return this.donationId__I;
  }
  price__I?: number = undefined;
  priceIsSet: boolean = false;
  set price(v: undefined | number) {
    if (v !== undefined) {
      this.price__I = v;
      this.priceIsSet = true;
    } else {
      this.price__I = v || undefined;
      this.priceIsSet = false;
    }
    this.changeTracker = true;
  }
  get price() {
    return this.price__I;
  }
  purchasableState__I?: PurchasableState = undefined;
  purchasableStateIsSet: boolean = false;
  set purchasableState(v: undefined | PurchasableState) {
    if (v !== undefined) {
      this.purchasableState__I = v;
      this.purchasableStateIsSet = true;
    } else {
      this.purchasableState__I = v || undefined;
      this.purchasableStateIsSet = false;
    }
    this.changeTracker = true;
  }
  get purchasableState() {
    return this.purchasableState__I;
  }
  purchaseDate__I?: Date = undefined;
  purchaseDateIsSet: boolean = false;
  set purchaseDate(v: undefined | Date) {
    if (v !== undefined) {
      this.purchaseDate__I = v;
      this.purchaseDateIsSet = true;
    } else {
      this.purchaseDate__I = v || undefined;
      this.purchaseDateIsSet = false;
    }
    this.changeTracker = true;
  }
  get purchaseDate() {
    return this.purchaseDate__I;
  }
  voidCloseId__I?: number = undefined;
  voidCloseIdIsSet: boolean = false;
  set voidCloseId(v: undefined | number) {
    if (v !== undefined) {
      this.voidCloseId__I = v;
      this.voidCloseIdIsSet = true;
    } else {
      this.voidCloseId__I = v || undefined;
      this.voidCloseIdIsSet = false;
    }
    this.changeTracker = true;
  }
  get voidCloseId() {
    return this.voidCloseId__I;
  }
  fundId__I?: DonationFundRefTracked = undefined;
  fundIdIsSet: boolean = false;
  set fundId(v: undefined | DonationFundRefTracked) {
    if (v !== undefined) {
      this.fundId__I = v;
      this.fundIdIsSet = true;
    } else {
      this.fundId__I = v || undefined;
      this.fundIdIsSet = true;
    }
    this.changeTracker = true;
  }
  get fundId() {
    return this.fundId__I;
  }
  donationDate__I?: Date = undefined;
  donationDateIsSet: boolean = false;
  set donationDate(v: undefined | Date) {
    if (v !== undefined) {
      this.donationDate__I = v;
      this.donationDateIsSet = true;
    } else {
      this.donationDate__I = v || undefined;
      this.donationDateIsSet = false;
    }
    this.changeTracker = true;
  }
  get donationDate() {
    return this.donationDate__I;
  }
  description__I?: string = undefined;
  descriptionIsSet: boolean = false;
  set description(v: undefined | string) {
    if (v !== undefined) {
      this.description__I = v;
      this.descriptionIsSet = true;
    } else {
      this.description__I = v || undefined;
      this.descriptionIsSet = false;
    }
    this.changeTracker = true;
  }
  get description() {
    return this.description__I;
  }
  restriction__I?: string = undefined;
  restrictionIsSet: boolean = false;
  set restriction(v: undefined | string) {
    if (v !== undefined) {
      this.restriction__I = v;
      this.restrictionIsSet = true;
    } else {
      this.restriction__I = v || undefined;
      this.restrictionIsSet = false;
    }
    this.changeTracker = true;
  }
  get restriction() {
    return this.restriction__I;
  }
  initiativeId__I?: DonationInitiativeRefTracked = undefined;
  initiativeIdIsSet: boolean = false;
  set initiativeId(v: undefined | DonationInitiativeRefTracked) {
    if (v !== undefined) {
      this.initiativeId__I = v;
      this.initiativeIdIsSet = true;
    } else {
      this.initiativeId__I = v || undefined;
      this.initiativeIdIsSet = true;
    }
    this.changeTracker = true;
  }
  get initiativeId() {
    return this.initiativeId__I;
  }
  inMemoryOf__I?: string = undefined;
  inMemoryOfIsSet: boolean = false;
  set inMemoryOf(v: undefined | string) {
    if (v !== undefined) {
      this.inMemoryOf__I = v;
      this.inMemoryOfIsSet = true;
    } else {
      this.inMemoryOf__I = v || undefined;
      this.inMemoryOfIsSet = false;
    }
    this.changeTracker = true;
  }
  get inMemoryOf() {
    return this.inMemoryOf__I;
  }
  isMatch__I?: boolean = undefined;
  isMatchIsSet: boolean = false;
  set isMatch(v: undefined | boolean) {
    if (v !== undefined) {
      this.isMatch__I = v;
      this.isMatchIsSet = true;
    } else {
      this.isMatch__I = v || undefined;
      this.isMatchIsSet = false;
    }
    this.changeTracker = true;
  }
  get isMatch() {
    return this.isMatch__I;
  }
  inKind__I?: boolean = undefined;
  inKindIsSet: boolean = false;
  set inKind(v: undefined | boolean) {
    if (v !== undefined) {
      this.inKind__I = v;
      this.inKindIsSet = true;
    } else {
      this.inKind__I = v || undefined;
      this.inKindIsSet = false;
    }
    this.changeTracker = true;
  }
  get inKind() {
    return this.inKind__I;
  }
  skipAck__I?: boolean = undefined;
  skipAckIsSet: boolean = false;
  set skipAck(v: undefined | boolean) {
    if (v !== undefined) {
      this.skipAck__I = v;
      this.skipAckIsSet = true;
    } else {
      this.skipAck__I = v || undefined;
      this.skipAckIsSet = false;
    }
    this.changeTracker = true;
  }
  get skipAck() {
    return this.skipAck__I;
  }
  personId__I?: PersonRefTracked = undefined;
  personIdIsSet: boolean = false;
  set personId(v: undefined | PersonRefTracked) {
    if (v !== undefined) {
      this.personId__I = v;
      this.personIdIsSet = true;
    } else {
      this.personId__I = v || undefined;
      this.personIdIsSet = false;
    }
    this.changeTracker = true;
  }
  get personId() {
    return this.personId__I;
  }
  constructor(config?: DonationFullOptional, options?: AssignOptions) {
    super(config, options);
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    if (this.donationIdIsSet == true && other?.donationIdIsSet == true)
      return this.donationId == other.donationId;

    return this == other;
  }
  setIds() {
    if (this.anySet() && !!this.donationId) {
      this.donationIdIsSet = true;
    }

    this.fundId?.setIds();

    this.initiativeId?.setIds();

    this.personId?.setIds();
  }
  assignFrom(
    config: DonationFullOptional,
    options?: AssignOptions,
  ): DonationFullTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (config.isDeleted && this.isDeletedApplyFilter(optionsRequired.filter)) {
      this.isDeleted = config.isDeleted;
      if (optionsRequired.unassign) this.isDeletedIsSet = false;
      else this.isDeletedIsSet = true;
    }
    if (config.isNew && this.isNewApplyFilter(optionsRequired.filter)) {
      this.isNew = config.isNew;
      if (optionsRequired.unassign) this.isNewIsSet = false;
      else this.isNewIsSet = true;
    }
    if (
      config.donationId &&
      this.donationIdApplyFilter(optionsRequired.filter)
    ) {
      this.donationId = config.donationId;
      if (optionsRequired.unassign) this.donationIdIsSet = false;
      else this.donationIdIsSet = true;
    }
    if (config.price && this.priceApplyFilter(optionsRequired.filter)) {
      this.price = config.price;
      if (optionsRequired.unassign) this.priceIsSet = false;
      else this.priceIsSet = true;
    }
    if (
      config.purchasableState &&
      this.purchasableStateApplyFilter(optionsRequired.filter)
    ) {
      this.purchasableState = config.purchasableState;
      if (optionsRequired.unassign) this.purchasableStateIsSet = false;
      else this.purchasableStateIsSet = true;
    }
    if (
      config.purchaseDate &&
      this.purchaseDateApplyFilter(optionsRequired.filter)
    ) {
      this.purchaseDate = config.purchaseDate;
      if (optionsRequired.unassign) this.purchaseDateIsSet = false;
      else this.purchaseDateIsSet = true;
    }
    if (
      config.voidCloseId &&
      this.voidCloseIdApplyFilter(optionsRequired.filter)
    ) {
      this.voidCloseId = config.voidCloseId;
      if (optionsRequired.unassign) this.voidCloseIdIsSet = false;
      else this.voidCloseIdIsSet = true;
    }
    if (config.fundId && this.fundIdApplyFilter(optionsRequired.filter)) {
      this.fundId = new DonationFundRefTracked(config.fundId, options);
      if (optionsRequired.unassign) this.fundIdIsSet = false;
      else this.fundIdIsSet = true;
    }
    if (
      config.donationDate &&
      this.donationDateApplyFilter(optionsRequired.filter)
    ) {
      this.donationDate = config.donationDate;
      if (optionsRequired.unassign) this.donationDateIsSet = false;
      else this.donationDateIsSet = true;
    }
    if (
      config.description &&
      this.descriptionApplyFilter(optionsRequired.filter)
    ) {
      this.description = config.description;
      if (optionsRequired.unassign) this.descriptionIsSet = false;
      else this.descriptionIsSet = true;
    }
    if (
      config.restriction &&
      this.restrictionApplyFilter(optionsRequired.filter)
    ) {
      this.restriction = config.restriction;
      if (optionsRequired.unassign) this.restrictionIsSet = false;
      else this.restrictionIsSet = true;
    }
    if (
      config.initiativeId &&
      this.initiativeIdApplyFilter(optionsRequired.filter)
    ) {
      this.initiativeId = new DonationInitiativeRefTracked(
        config.initiativeId,
        options,
      );
      if (optionsRequired.unassign) this.initiativeIdIsSet = false;
      else this.initiativeIdIsSet = true;
    }
    if (
      config.inMemoryOf &&
      this.inMemoryOfApplyFilter(optionsRequired.filter)
    ) {
      this.inMemoryOf = config.inMemoryOf;
      if (optionsRequired.unassign) this.inMemoryOfIsSet = false;
      else this.inMemoryOfIsSet = true;
    }
    if (config.isMatch && this.isMatchApplyFilter(optionsRequired.filter)) {
      this.isMatch = config.isMatch;
      if (optionsRequired.unassign) this.isMatchIsSet = false;
      else this.isMatchIsSet = true;
    }
    if (config.inKind && this.inKindApplyFilter(optionsRequired.filter)) {
      this.inKind = config.inKind;
      if (optionsRequired.unassign) this.inKindIsSet = false;
      else this.inKindIsSet = true;
    }
    if (config.skipAck && this.skipAckApplyFilter(optionsRequired.filter)) {
      this.skipAck = config.skipAck;
      if (optionsRequired.unassign) this.skipAckIsSet = false;
      else this.skipAckIsSet = true;
    }
    if (config.personId && this.personIdApplyFilter(optionsRequired.filter)) {
      this.personId = new PersonRefTracked(config.personId, options);
      if (optionsRequired.unassign) this.personIdIsSet = false;
      else this.personIdIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): DonationFullTrackedI {
    const cloned = {} as DonationFullTrackedI;
    if (
      this.isDeletedIsSetDeep() &&
      this.isDeletedApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isDeletedIsSet = true;
      cloned.isDeleted = this.isDeleted;
    } else {
      //cloned.isDeletedIsSet = false
    }
    if (
      this.isNewIsSetDeep() &&
      this.isNewApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isNewIsSet = true;
      cloned.isNew = this.isNew;
    } else {
      //cloned.isNewIsSet = false
    }
    if (
      this.donationIdIsSetDeep() &&
      this.donationIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.donationIdIsSet = true;
      cloned.donationId = this.donationId;
    } else {
      //cloned.donationIdIsSet = false
    }
    if (
      this.priceIsSetDeep() &&
      this.priceApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.priceIsSet = true;
      cloned.price = this.price;
    } else {
      //cloned.priceIsSet = false
    }
    if (
      this.purchasableStateIsSetDeep() &&
      this.purchasableStateApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.purchasableStateIsSet = true;
      cloned.purchasableState = this.purchasableState;
    } else {
      //cloned.purchasableStateIsSet = false
    }
    if (
      this.purchaseDateIsSetDeep() &&
      this.purchaseDateApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.purchaseDateIsSet = true;
      cloned.purchaseDate = this.purchaseDate;
    } else {
      //cloned.purchaseDateIsSet = false
    }
    if (
      this.voidCloseIdIsSetDeep() &&
      this.voidCloseIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.voidCloseIdIsSet = true;
      cloned.voidCloseId = this.voidCloseId;
    } else {
      //cloned.voidCloseIdIsSet = false
    }
    if (
      this.fundIdIsSetDeep() &&
      this.fundIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.fundIdIsSet = true;
      cloned.fundId = this.fundId?.removeUnset(filter);
    } else {
      //cloned.fundIdIsSet = false
    }
    if (
      this.donationDateIsSetDeep() &&
      this.donationDateApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.donationDateIsSet = true;
      cloned.donationDate = this.donationDate;
    } else {
      //cloned.donationDateIsSet = false
    }
    if (
      this.descriptionIsSetDeep() &&
      this.descriptionApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.descriptionIsSet = true;
      cloned.description = this.description;
    } else {
      //cloned.descriptionIsSet = false
    }
    if (
      this.restrictionIsSetDeep() &&
      this.restrictionApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.restrictionIsSet = true;
      cloned.restriction = this.restriction;
    } else {
      //cloned.restrictionIsSet = false
    }
    if (
      this.initiativeIdIsSetDeep() &&
      this.initiativeIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.initiativeIdIsSet = true;
      cloned.initiativeId = this.initiativeId?.removeUnset(filter);
    } else {
      //cloned.initiativeIdIsSet = false
    }
    if (
      this.inMemoryOfIsSetDeep() &&
      this.inMemoryOfApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.inMemoryOfIsSet = true;
      cloned.inMemoryOf = this.inMemoryOf;
    } else {
      //cloned.inMemoryOfIsSet = false
    }
    if (
      this.isMatchIsSetDeep() &&
      this.isMatchApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isMatchIsSet = true;
      cloned.isMatch = this.isMatch;
    } else {
      //cloned.isMatchIsSet = false
    }
    if (
      this.inKindIsSetDeep() &&
      this.inKindApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.inKindIsSet = true;
      cloned.inKind = this.inKind;
    } else {
      //cloned.inKindIsSet = false
    }
    if (
      this.skipAckIsSetDeep() &&
      this.skipAckApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.skipAckIsSet = true;
      cloned.skipAck = this.skipAck;
    } else {
      //cloned.skipAckIsSet = false
    }
    if (
      this.personIdIsSetDeep() &&
      this.personIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.personIdIsSet = true;
      cloned.personId = this.personId?.removeUnset(filter);
    } else {
      //cloned.personIdIsSet = false
    }
    if (!isDeleted(this) && !this.donationIdIsSet) updateIsNew(cloned, true);
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): DonationFullTrackedI {
    if (!this.isDeletedApplyFilter(filter)) this.isDeletedIsSet = false;

    if (!this.isNewApplyFilter(filter)) this.isNewIsSet = false;

    if (!this.donationIdApplyFilter(filter)) this.donationIdIsSet = false;

    if (!this.priceApplyFilter(filter)) this.priceIsSet = false;

    if (!this.purchasableStateApplyFilter(filter))
      this.purchasableStateIsSet = false;

    if (!this.purchaseDateApplyFilter(filter)) this.purchaseDateIsSet = false;

    if (!this.voidCloseIdApplyFilter(filter)) this.voidCloseIdIsSet = false;

    if (!this.fundIdApplyFilter(filter)) this.fundIdIsSet = false;
    this.fundId?.unassignAll(filter);

    if (!this.donationDateApplyFilter(filter)) this.donationDateIsSet = false;

    if (!this.descriptionApplyFilter(filter)) this.descriptionIsSet = false;

    if (!this.restrictionApplyFilter(filter)) this.restrictionIsSet = false;

    if (!this.initiativeIdApplyFilter(filter)) this.initiativeIdIsSet = false;
    this.initiativeId?.unassignAll(filter);

    if (!this.inMemoryOfApplyFilter(filter)) this.inMemoryOfIsSet = false;

    if (!this.isMatchApplyFilter(filter)) this.isMatchIsSet = false;

    if (!this.inKindApplyFilter(filter)) this.inKindIsSet = false;

    if (!this.skipAckApplyFilter(filter)) this.skipAckIsSet = false;

    if (!this.personIdApplyFilter(filter)) this.personIdIsSet = false;
    this.personId?.unassignAll(filter);

    return this;
  }
  isDeletedApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      DonationFullMeta.isDeleted,
      DonationFullMeta,
      this.isDeleted,
      this,
    );
  }
  isDeletedIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isDeletedIsSet && this.isDeletedApplyFilter(filter)) return true;

    return false;
  }
  isNewApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(DonationFullMeta.isNew, DonationFullMeta, this.isNew, this);
  }
  isNewIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isNewIsSet && this.isNewApplyFilter(filter)) return true;

    return false;
  }
  donationIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      DonationFullMeta.donationId,
      DonationFullMeta,
      this.donationId,
      this,
    );
  }
  donationIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.donationIdIsSet && this.donationIdApplyFilter(filter)) return true;

    return false;
  }
  priceApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(DonationFullMeta.price, DonationFullMeta, this.price, this);
  }
  priceIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.priceIsSet && this.priceApplyFilter(filter)) return true;

    return false;
  }
  purchasableStateApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      DonationFullMeta.purchasableState,
      DonationFullMeta,
      this.purchasableState,
      this,
    );
  }
  purchasableStateIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.purchasableStateIsSet && this.purchasableStateApplyFilter(filter))
      return true;

    return false;
  }
  purchaseDateApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      DonationFullMeta.purchaseDate,
      DonationFullMeta,
      this.purchaseDate,
      this,
    );
  }
  purchaseDateIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.purchaseDateIsSet && this.purchaseDateApplyFilter(filter))
      return true;

    return false;
  }
  voidCloseIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      DonationFullMeta.voidCloseId,
      DonationFullMeta,
      this.voidCloseId,
      this,
    );
  }
  voidCloseIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.voidCloseIdIsSet && this.voidCloseIdApplyFilter(filter))
      return true;

    return false;
  }
  fundIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(DonationFullMeta.fundId, DonationFullMeta, this.fundId, this);
  }
  fundIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.fundIdIsSet && this.fundIdApplyFilter(filter)) return true;
    return this.fundId?.anySet(filter) == true;

    return false;
  }
  donationDateApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      DonationFullMeta.donationDate,
      DonationFullMeta,
      this.donationDate,
      this,
    );
  }
  donationDateIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.donationDateIsSet && this.donationDateApplyFilter(filter))
      return true;

    return false;
  }
  descriptionApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      DonationFullMeta.description,
      DonationFullMeta,
      this.description,
      this,
    );
  }
  descriptionIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.descriptionIsSet && this.descriptionApplyFilter(filter))
      return true;

    return false;
  }
  restrictionApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      DonationFullMeta.restriction,
      DonationFullMeta,
      this.restriction,
      this,
    );
  }
  restrictionIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.restrictionIsSet && this.restrictionApplyFilter(filter))
      return true;

    return false;
  }
  initiativeIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      DonationFullMeta.initiativeId,
      DonationFullMeta,
      this.initiativeId,
      this,
    );
  }
  initiativeIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.initiativeIdIsSet && this.initiativeIdApplyFilter(filter))
      return true;
    return this.initiativeId?.anySet(filter) == true;

    return false;
  }
  inMemoryOfApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      DonationFullMeta.inMemoryOf,
      DonationFullMeta,
      this.inMemoryOf,
      this,
    );
  }
  inMemoryOfIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.inMemoryOfIsSet && this.inMemoryOfApplyFilter(filter)) return true;

    return false;
  }
  isMatchApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      DonationFullMeta.isMatch,
      DonationFullMeta,
      this.isMatch,
      this,
    );
  }
  isMatchIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isMatchIsSet && this.isMatchApplyFilter(filter)) return true;

    return false;
  }
  inKindApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(DonationFullMeta.inKind, DonationFullMeta, this.inKind, this);
  }
  inKindIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.inKindIsSet && this.inKindApplyFilter(filter)) return true;

    return false;
  }
  skipAckApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      DonationFullMeta.skipAck,
      DonationFullMeta,
      this.skipAck,
      this,
    );
  }
  skipAckIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.skipAckIsSet && this.skipAckApplyFilter(filter)) return true;

    return false;
  }
  personIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      DonationFullMeta.personId,
      DonationFullMeta,
      this.personId,
      this,
    );
  }
  personIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.personIdIsSet && this.personIdApplyFilter(filter)) return true;
    return this.personId?.anySet(filter) == true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.isDeletedIsSetDeep(filter)) return true;
    if (this.isNewIsSetDeep(filter)) return true;
    if (this.donationIdIsSetDeep(filter)) return true;
    if (this.priceIsSetDeep(filter)) return true;
    if (this.purchasableStateIsSetDeep(filter)) return true;
    if (this.purchaseDateIsSetDeep(filter)) return true;
    if (this.voidCloseIdIsSetDeep(filter)) return true;
    if (this.fundIdIsSetDeep(filter)) return true;
    if (this.donationDateIsSetDeep(filter)) return true;
    if (this.descriptionIsSetDeep(filter)) return true;
    if (this.restrictionIsSetDeep(filter)) return true;
    if (this.initiativeIdIsSetDeep(filter)) return true;
    if (this.inMemoryOfIsSetDeep(filter)) return true;
    if (this.isMatchIsSetDeep(filter)) return true;
    if (this.inKindIsSetDeep(filter)) return true;
    if (this.skipAckIsSetDeep(filter)) return true;
    if (this.personIdIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
